import { IBranch } from "src/app/interfaces/branch";
import { TranslateService } from "@ngstack/translate";
import { ICompany } from "./../../../../interfaces/company";
import { Component, OnInit, ViewChild, OnDestroy } from "@angular/core";

import { IConfirm } from "src/app/interfaces/confirm";
import {
  MatTableDataSource,
  MatPaginator,
  MatDialog,
  MatSelectChange
} from "@angular/material";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { CourseService } from "src/app/services/http/business/course/course.service";
import { AddTeacherEntryComponent } from "../add-teacher-entry/add-teacher-entry.component";
import { ErrorsService } from "src/app/services/common/errors.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { CIDService } from "src/app/services/common/cid.service";
import { BIDService } from "src/app/services/common/bid.service";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { CourseListSearchComponent } from "./course-list-search/course-list-search.component";
import { HttpHeaders } from "@angular/common/http";
import { RegisterStudentCourseComponent } from "../register-student-course/register-student-course.component";
import { environment } from "src/environments/environment";
// import { TPATeacherComponent } from "../tpa-teacher/tpa-teacher.component";

@Component({
  selector: "app-course-list",
  templateUrl: "./course-list.component.html",
  styleUrls: ["./course-list.component.css"]
})
export class CourseListComponent implements OnInit, OnDestroy {
  UrlSessionReport: string;
  UrlCourseReport: string;
  isOwner: boolean;
  branchList: IBranch;
  companyList: ICompany;
  hasFreeTeacher: boolean;
  filter: any;
  companySelected: string;
  branchEncryptId: string;
  userBranchEncryptId = this.bidService.getBID();
  dataSource = new MatTableDataSource();
  header: any;

  displayedColumns: string[] = [
    this.translate.get("label.level"),
    "branch",
    this.translate.get("label.teacherName"),
    "date",
    this.translate.get("label.pattern"),
    this.translate.get("label.discount"),
    this.translate.get("label.isRegisterd"),
    this.translate.get("label.room"),
    this.translate.get("label.status"),
    "report",
    "function"
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;


  constructor(
    private dialog: MatDialog,
    private bidService: BIDService,
    private cidService: CIDService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private branchService: BranchService,
    private courseService: CourseService,
    private companyService: CompanyService,
    private holdingService: HoldingService
  ) { }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.checkOwner();
    this.companySelected = this.cidService.getCID();
    if (this.companySelected.length > 0) {
      this.getBranchList(this.cidService.getCID());
    }
    this.UrlCourseReport = environment.ReportBaseUrl + "Education/CorseStudenShow?CourseId=";
    this.UrlSessionReport = environment.ReportBaseUrl + "Education/GetClassListShow?CourseId="
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner)
        this.getCompanyList();
      else
        this.refresh();
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  getBranchList(company) {
    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );
    this.branchService.listByCompanyHeader(0, 0, headers).subscribe(res => {
      this.branchList = res.DataList;
    });
  }

  loadBranch(e: any) {
    this.cidService.setCID(e);
    if (this.isOwner)
      this.bidService.removeBID();
    this.paginator.length = 0;
    this.getBranchList(e);

    this.dataSource = null;
    this.filter = null;
    this.refresh();
  }

  showStudentList(course: any) {
    course.CourseId = course.Id;
    course.LevelName = course.LevelInfoName;
    course.CoursePatternTitle = course.CoursePatternName;
    course.TimeEnd = course.EndTime;
    course.TimeStart = course.StartTime;
    this.dialog.open(RegisterStudentCourseComponent, {
      width: "750px",
      data: course
    });
  }

  search() {
    this.dialog
      .open(CourseListSearchComponent, {
        width: '800px',
        data: null
      })
      .afterClosed()
      .subscribe(res => {
        this.filter = res.filter;
        this.header = res.header;
        this.refresh();
      });
  }

  loadDataTable(e: MatSelectChange) {
    this.dataSource = null;
    if (this.isOwner)
      this.bidService.setBID(e.value);
    this.filter = null;
    this.header = null;
    this.refresh();
  }

  refresh() {
    debugger
    if (this.header)
      this.courseService.listByCompany(this.filter, 1, 10, this.header).subscribe(res => {
        this.dataSource = null;
        this.dataSource = res.DataList;
        this.paginator.length = res.Total;
        this.paginator.pageIndex = 0;
        this.paginator.pageSize = 10;
      });
    else
      this.courseService.list(this.filter, 1, 10).subscribe(res => {
        this.dataSource = null;
        this.dataSource = res.DataList;
        this.paginator.length = res.Total;
        this.paginator.pageIndex = 0;
        this.paginator.pageSize = 10;
      });
  }

  paginatorEvent(event) {
    debugger
    if (this.header)
      this.courseService.listByCompany(this.filter, event.pageIndex + 1, event.pageSize, this.header)
        .subscribe(res => {
          this.dataSource = new MatTableDataSource(res.DataList);
          this.paginator.length = res.Total;
        });
    else
      this.courseService.list(this.filter, event.pageIndex + 1, event.pageSize)
        .subscribe(res => {
          this.dataSource = new MatTableDataSource(res.DataList);
          this.paginator.length = res.Total;
        });
  }

  addTeacher(id: number) {
    let data = {
      Id: id
    };
    this.courseService.getListIndeterminate(data).subscribe(res => {
      res.Id = id;
      this.dialog
        .open(AddTeacherEntryComponent, {
          data: res,
          width: "500px"
        })
        .afterClosed()
        .subscribe(() => {
          this.refresh();
        });
    });
  }

  delete(id: number) {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.cancel", {
        name: this.translate.get("label.course")
      }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog
      .open(ConfirmComponent, {
        width: "250px",
        data: confirm
      })
      .afterClosed()
      .subscribe(
        res => {
          if (res) {
            let params = {
              Id: id
            };
            this.courseService.delete(params).subscribe(() => {
              this.refresh();
            });
          }
        },
        err => {
          this.errorService.recordHasBennUsed(err);
        }
      );
  }

  cancelCourse(id: number) {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.cancel", {
        name: this.translate.get("label.course")
      }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog
      .open(ConfirmComponent, {
        width: "250px",
        data: confirm
      })
      .afterClosed()
      .subscribe(
        res => {
          if (res) {
            let params = {
              Id: id
            };
            this.courseService.cancelCourse(params).subscribe(() => {
              this.refresh();
            });
          }
        },
        err => {
          this.errorService.recordHasBennUsed(err);
        }
      );
  }

  activeCourse(id: number) {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.active", {
        name: this.translate.get("label.course")
      }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog
      .open(ConfirmComponent, {
        width: "250px",
        data: confirm
      })
      .afterClosed()
      .subscribe(
        res => {
          if (res) {
            let params = {
              Id: id
            };
            this.courseService.activeCourse(params).subscribe(() => {
              this.refresh();
            });
          }
        },
        err => {
          this.errorService.recordHasBennUsed(err);
        }
      );
  }

  // showTpa(req: any) {
  //   console.log(req);

  //   //     AmountOfUnit: 0
  //   // BranchEncryptId: "4wKVFLWEfWX+v7SKv1Gnzg=="
  //   // BranchName: "صادقيه"
  //   // CapacityFree: 11
  //   // CapacityFreeOnline: null
  //   // Coefficient: 2
  //   // CourseDeadLineDatePersian: null
  //   // CoursePatternId: 32
  //   // CoursePatternName: "فشرده فرد"
  //   // CourseStatusId: 10
  //   // CourseStatusName: "فعال"
  //   // CourseTypeTitle: "فشرده هايبريد"
  //   // DiscountGroupDetailName: ""
  //   // DiscountGroupId: null
  //   // EduOrgCapacity: 18
  //   // EndDatePersian: "1400/08/16"
  //   // EndTime: "20:00:00"
  //   // Id: 354354
  //   // IsAsset: false
  //   // IsBatch: false
  //   // IsPrivate: false
  //   // LevelInfoId: 611
  //   // LevelInfoName: "302"
  //   // MaxCapacity: 13
  //   // OnlineCourseLink: null
  //   // PackageId: 15
  //   // PackageName: "New Hybrid"
  //   // ParentId: null
  //   // ParentTermName: "ترم پنج"
  //   // RegistrationCount: 0
  //   // RegistredStudent: false
  //   // RoomCapacity: false
  //   // RoomId: 470
  //   // RoomName: "27 | کد: 354354"
  //   // SexualityId: 42
  //   // SexualityName: "مختلط"
  //   // StartDate: "2021-10-21T00:00:00"
  //   // StartDatePersian: "1400/07/29"
  //   // StartTime: "16:45:00"
  //   // TeacherFullName: "صمد صالحی"
  //   // TeacherUserEncryptId: "mQXIGCtIilWHa8ELY9WOPg=="
  //   // TermInfoId: 4478
  //   // TermInfoName: "716 - فشرده2 ترم5(400) "

  //   this.dialog.open(TPATeacherComponent, {
  //     width: "80%",
  //     data: {
  //       CourseId: req.Id,
  //       CoursePatternId: req.CoursePatternId,
  //       CoursePatternTitle: req.CoursePatternName,
  //       CourseStatusId: req.CourseStatusId,
  //       CourseStatusTitle: req.CourseStatusName,
  //       CourseTypeTitle: req.CourseTypeTitle,
  //       FullName: req.TeacherFullName,
  //       LevelInfoId: req.LevelInfoId,
  //       LevelName: req.LevelInfoName,
  //       RegistrationCount: req.RegistrationCount,
  //       TermInfoId: req.TermInfoId,
  //       TermInfoName: req.TermInfoName,
  //       TimeEnd: req.EndTime,
  //       TimeStart: req.StartTime
  //     }
  //   }).afterClosed()
  //     .subscribe(() => {
  //       //this.submitTermInfo(this.termInfoForm.value)
  //     });
  // }

  ngOnDestroy(): void {
    if (this.isOwner)
      this.bidService.setBID("");
  }
}
